/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResourceRoleDto } from '../../models/resource-role-dto';

export interface GetResourceRoles$Params {
      body: Array<string>
}

export function getResourceRoles(http: HttpClient, rootUrl: string, params: GetResourceRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResourceRoleDto>>> {
  const rb = new RequestBuilder(rootUrl, getResourceRoles.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResourceRoleDto>>;
    })
  );
}

getResourceRoles.PATH = '/case-resources/roles';
